(() => {
  'use strict';
  const ready = new WeakSet();
  const groups = ['style', 'color', 'size', 'config', 'stock'];
  const unique = values => [...new Set(values.filter(Boolean))];
  const numericSort = (a, b) => String(a).localeCompare(String(b), undefined, { numeric: true });
  const colorValue = name => {
    const n = String(name).toLowerCase();
    if (/holographic|chameleon/.test(n)) return 'linear-gradient(135deg,#597fbe,#a274a9,#5cba9f)';
    if (/red/.test(n)) return 'linear-gradient(135deg,#ad323b 50%,#f1f1ed 50%)';
    if (/cyan|green/.test(n)) return '#93d8c0';
    if (/white/.test(n)) return '#f2f2ef';
    if (/silver/.test(n)) return '#babdbd';
    if (/titanium/.test(n)) return 'linear-gradient(135deg,#252525 50%,#a1936e 50%)';
    if (/gray|grey/.test(n)) return 'linear-gradient(135deg,#898b8a 50%,#373937 50%)';
    return '#222';
  };
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100) + ' ' + currency;
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text != null) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function init(root) {
    if (ready.has(root)) return;
    ready.add(root);
    const labels = JSON.parse(root.querySelector('[data-bikes-labels]').textContent);
    const form = root.querySelector('[data-bikes-filter-form]');
    const filterDialog = root.querySelector('[data-bikes-filters]');
    const compareDialog = root.querySelector('[data-bikes-compare-dialog]');
    const track = root.querySelector('[data-bikes-cards]');
    const sorter = root.querySelector('[data-bikes-sort]');
    const minimum = form.elements.namedItem('bc_min');
    const maximum = form.elements.namedItem('bc_max');
    const defaultCurrency = root.dataset.currency || 'USD';
    const pageSize = Math.max(1, Number(root.dataset.pageSize) || 12);
    const desktop = window.matchMedia('(min-width: 901px)');
    const base = document.baseURI || location.href;
    const url = new URL(base);
    const records = [...track.querySelectorAll('[data-bc-card]')].map((card, index) => {
      const data = JSON.parse(card.querySelector('[data-bc-card-data]').textContent);
      return { card, data, index, selectedColor: card.querySelector('[data-bc-card-color][aria-pressed="true"]')?.dataset.bcCardColor, price: Infinity, variant: null };
    });
    const denomination = unique(records.map(r => r.data.currency || defaultCurrency));
    if (denomination.length === 1) root.querySelector('[data-bikes-currency]').textContent = denomination[0];
    const state = Object.fromEntries(groups.map(group => [group, url.searchParams.getAll('bc_' + group)]));
    state.min = url.searchParams.get('bc_min') || '';
    state.max = url.searchParams.get('bc_max') || '';
    minimum.value = state.min;
    maximum.value = state.max;
    let page = 1, matches = [], view = url.searchParams.get('bc_view') || 'grid';
    let focusFilterButton = false, priceTimer;
    const selected = new Set();
    const slots = { color: 'colorPosition', size: 'sizePosition', config: 'configPosition' };
    const valuesFor = (record, group) => {
      if (group === 'style') return [record.data.style];
      if (group === 'stock') return ['in', 'out'];
      return unique(record.data.variants.map(v => v.options[record.data[slots[group]] - 1]));
    };
    const labelFor = (group, value) => group === 'style' ? labels[value] || value : group === 'stock' ? labels[value === 'in' ? 'available' : 'unavailable'] : value;
    const matchingVariants = (record, except) => record.data.variants.filter(variant => {
      if (except !== 'style' && state.style.length && !state.style.includes(record.data.style)) return false;
      for (const group of ['color', 'size', 'config']) {
        if (except !== group && state[group].length && !state[group].includes(variant.options[record.data[slots[group]] - 1])) return false;
      }
      if (except !== 'stock' && state.stock.length && !state.stock.includes(variant.available ? 'in' : 'out')) return false;
      if (state.min !== '' && variant.price < Math.round(Number(state.min) * 100)) return false;
      if (state.max !== '' && variant.price > Math.round(Number(state.max) * 100)) return false;
      return true;
    });
    const optionNodes = [];
    groups.forEach(group => {
      const container = root.querySelector('[data-bikes-options="' + group + '"]');
      const values = group === 'stock' ? ['in', 'out'] : unique(records.flatMap(r => valuesFor(r, group))).sort(numericSort);
      container.replaceChildren();
      values.forEach(value => {
        const label = element('label', null, 'ct-cl-option');
        const input = element('input');
        input.type = 'checkbox';
        input.name = 'bc_' + group;
        input.value = value;
        input.checked = state[group].includes(value);
        const name = element('span', labelFor(group, value));
        const count = element('small');
        label.append(input, name, count);
        container.append(label);
        optionNodes.push({ group, value, input, count });
      });
    });
    const updateUrl = () => {
      if (!['http:', 'https:'].includes(location.protocol)) return;
      const next = new URL(location.href);
      groups.forEach(group => { next.searchParams.delete('bc_' + group); state[group].forEach(value => next.searchParams.append('bc_' + group, value)); });
      for (const key of ['min', 'max']) {
        if (state[key] !== '') next.searchParams.set('bc_' + key, state[key]);
        else next.searchParams.delete('bc_' + key);
      }
      if (sorter.value === 'featured') next.searchParams.delete('sort_by');
      else next.searchParams.set('sort_by', sorter.value);
      if (view === 'grid') next.searchParams.delete('bc_view');
      else next.searchParams.set('bc_view', view);
      history.replaceState(null, '', next);
    };
    const setView = value => {
      view = value === 'list' ? 'list' : 'grid';
      root.dataset.view = view;
      root.querySelectorAll('[data-bikes-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bikesView === view)));
    };
    if (!url.searchParams.has('bc_view')) { try { view = localStorage.getItem('cyctracCollectionView') || view; } catch {} }
    setView(view);
    if ([...sorter.options].some(o => o.value === url.searchParams.get('sort_by'))) sorter.value = url.searchParams.get('sort_by');
    const renderCard = (record, choices) => {
      if (!choices.length) return;
      const { card, data } = record;
      const preferred = choices.filter(v => v.options[data.colorPosition - 1] === record.selectedColor);
      const variant = [...(preferred.length ? preferred : choices)].sort((a, b) => a.price - b.price)[0];
      record.variant = variant;
      const color = variant.options[data.colorPosition - 1];
      card.querySelector('[data-bc-card-price]').textContent = money(variant.price, data.currency || defaultCurrency);
      card.querySelector('[data-bc-color-name]').textContent = color + (variant.image ? '' : ' · ' + labels.photoPending);
      const from = card.querySelector('.ct-bc-card__price small');
      if (from) from.hidden = choices.every(v => v.price === variant.price);
      const image = card.querySelector('[data-bc-card-image]');
      if (image && variant.image) {
        const src = new URL(variant.image, base);
        src.searchParams.set('width', '1000');
        image.src = src.href;
        image.srcset = [360, 600, 1000].map(width => { const u = new URL(variant.image, base); u.searchParams.set('width', String(width)); return u.href + ' ' + width + 'w'; }).join(', ');
        image.sizes = '(min-width: 1520px) 380px, (min-width: 901px) calc((100vw - 360px) / 3), (min-width: 601px) calc((100vw - 60px) / 2), calc(100vw - 32px)';
        image.alt = data.title + ' — ' + color;
      }
      const target = new URL(data.url, base);
      target.searchParams.set('variant', String(variant.id));
      card.querySelectorAll('[data-bc-product-link]').forEach(a => { a.href = target.href; });
      const input = card.querySelector('input[name="id"]');
      if (input) input.value = String(variant.id);
      const add = card.querySelector('[data-ct-pd-add]');
      if (add) add.disabled = data.preview || !variant.available;
      card.querySelectorAll('[data-bc-card-color]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.bcCardColor === color));
        button.disabled = !choices.some(v => v.options[data.colorPosition - 1] === button.dataset.bcCardColor);
      });
    };
    records.forEach(record => {
      record.card.querySelectorAll('[data-bc-card-color]').forEach(button => {
        button.style.setProperty('--swatch', colorValue(button.dataset.bcCardColor));
        button.addEventListener('click', () => { record.selectedColor = button.dataset.bcCardColor; renderCard(record, matchingVariants(record)); renderCompare(); });
      });
      let stats = record.card.querySelector('.ct-cl-card__specs');
      if (!stats) { stats = element('dl', null, 'ct-cl-card__specs'); record.card.append(stats); }
      stats.replaceChildren();
      record.configurations = valuesFor(record, 'config');
      record.sizes = valuesFor(record, 'size').sort(numericSort);
      (record.data.advantages || []).forEach(([name, value]) => {
        const div = element('div'); div.append(element('dt', name), element('dd', value)); stats.append(div);
      });
      const actions = record.card.querySelector('.ct-bc-card__actions');
      let checkbox = actions.querySelector('[data-bikes-compare]');
      if (!checkbox) {
        const label = element('label', null, 'ct-cl-compare-check');
        checkbox = element('input'); checkbox.type = 'checkbox'; checkbox.setAttribute('data-bikes-compare', '');
        label.append(checkbox, element('span', labels.compare)); actions.append(label);
      }
      checkbox.checked = false;
      checkbox.addEventListener('change', () => {
        if (checkbox.checked && selected.size >= 3) { checkbox.checked = false; root.querySelector('[data-bikes-compare-status]').textContent = labels.limit; return; }
        if (checkbox.checked) selected.add(record.data.id); else selected.delete(record.data.id);
        renderCompare();
      });
    });
    const clear = () => {
      form.reset();
      groups.forEach(group => { state[group] = []; });
      state.min = ''; state.max = ''; minimum.value = ''; maximum.value = '';
      maximum.setCustomValidity(''); root.querySelector('[data-bikes-price-error]').hidden = true;
      page = 1; render(); updateUrl();
    };
    const removeFilter = (group, value) => {
      if (group === 'min' || group === 'max') { state[group] = ''; (group === 'min' ? minimum : maximum).value = ''; }
      else {
        state[group] = state[group].filter(item => item !== value);
        optionNodes.filter(o => o.group === group && o.value === value).forEach(o => { o.input.checked = false; });
      }
      maximum.setCustomValidity(''); root.querySelector('[data-bikes-price-error]').hidden = true;
      page = 1; render(); updateUrl();
    };
    const renderChips = () => {
      const chips = root.querySelector('[data-bikes-active-filters]');
      chips.replaceChildren();
      const add = (group, value, text) => {
        const button = element('button'); button.type = 'button';
        button.setAttribute('aria-label', labels.remove + ': ' + text);
        button.append(element('span', text), element('span', '×'));
        button.addEventListener('click', () => removeFilter(group, value)); chips.append(button);
      };
      groups.forEach(group => state[group].forEach(value => add(group, value, labelFor(group, value))));
      ['min', 'max'].forEach(key => { if (state[key] !== '') add(key, state[key], labels[key] + ': ' + state[key]); });
      const count = chips.children.length;
      chips.hidden = count === 0;
      const badge = root.querySelector('[data-bikes-filter-count]'); badge.hidden = count === 0; badge.textContent = String(count);
      if (count) { const button = element('button', labels.clear); button.type = 'button'; button.addEventListener('click', clear); chips.append(button); }
    };
    const renderPagination = () => {
      const node = root.querySelector('[data-bikes-pagination]');
      const pages = Math.ceil(matches.length / pageSize);
      node.hidden = pages < 2; node.replaceChildren();
      if (pages < 2) return;
      for (let n = 1; n <= pages; n++) {
        const button = element('button', String(n)); button.type = 'button';
        button.setAttribute('aria-label', labels.page + ' ' + n);
        if (n === page) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => { page = n; render(); root.querySelector('.ct-cl-main').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        node.append(button);
      }
    };
    function renderCompare() {
      const chosen = records.filter(r => selected.has(r.data.id));
      root.querySelector('[data-bikes-compare-bar]').hidden = chosen.length === 0;
      root.querySelector('[data-bikes-compare-count]').textContent = labels.selected.replace('[count]', String(chosen.length));
      root.querySelector('[data-bikes-compare-status]').textContent = '';
      records.forEach(r => { const check = r.card.querySelector('[data-bikes-compare]'); check.checked = selected.has(r.data.id); check.disabled = selected.size >= 3 && !check.checked; });
      const tableRoot = root.querySelector('[data-bikes-compare-table]');
      tableRoot.replaceChildren();
      if (!chosen.length) return;
      const table = element('table');
      const body = element('tbody');
      const rows = [[labels.model, r => r.data.title], [labels.price, r => money(r.variant?.price || Math.min(...r.data.variants.map(v => v.price)), r.data.currency || defaultCurrency)], [labels.style, r => labels[r.data.style] || r.data.style], [labels.config, r => r.configurations.join(' · ')], [labels.sizes, r => r.sizes.join(' · ')], [labels.highlights, r => (r.data.advantages || []).map(([name,value]) => name + ': ' + value).join(' · ')]];
      rows.forEach(([name, value]) => { const tr = element('tr'); const heading = element('th', name); heading.scope = 'row'; tr.append(heading); chosen.forEach(record => tr.append(element('td', value(record)))); body.append(tr); });
      const links = element('tr'); links.append(element('th', ''));
      chosen.forEach(record => { const td = element('td'); const link = element('a', labels.view + ' →'); link.href = record.card.querySelector('[data-bc-product-link]').href; td.append(link); links.append(td); });
      body.append(links); table.append(body); tableRoot.append(table);
    }
    function render() {
      matches = [];
      records.forEach(record => {
        const choices = matchingVariants(record);
        record.price = choices.length ? Math.min(...choices.map(v => v.price)) : Infinity;
        if (choices.length) { matches.push(record); renderCard(record, choices); }
      });
      const sort = sorter.value;
      if (sort === 'price-ascending') matches.sort((a, b) => a.price - b.price || a.index - b.index);
      else if (sort === 'price-descending') matches.sort((a, b) => b.price - a.price || a.index - b.index);
      else if (sort === 'title-ascending') matches.sort((a, b) => numericSort(a.data.title, b.data.title));
      else if (sort === 'title-descending') matches.sort((a, b) => numericSort(b.data.title, a.data.title));
      page = Math.max(1, Math.min(page, Math.ceil(matches.length / pageSize) || 1));
      records.forEach(record => { record.card.hidden = true; });
      matches.forEach((record, index) => { track.append(record.card); record.card.hidden = index < (page - 1) * pageSize || index >= page * pageSize; });
      root.querySelector('[data-bikes-result-count]').textContent = matches.length === 1 ? labels.one : labels.count.replace('[count]', String(matches.length));
      root.querySelector('[data-bikes-show-results]').textContent = labels.show.replace('[count]', String(matches.length));
      root.querySelector('[data-bikes-empty]').hidden = matches.length > 0;
      optionNodes.forEach(option => {
        let count = 0;
        records.forEach(record => {
          const found = matchingVariants(record, option.group).some(variant => option.group === 'style' ? record.data.style === option.value : option.group === 'stock' ? (variant.available ? 'in' : 'out') === option.value : variant.options[record.data[slots[option.group]] - 1] === option.value);
          if (found) count++;
        });
        option.count.textContent = '(' + count + ')';
        option.input.disabled = count === 0 && !option.input.checked;
      });
      renderChips(); renderPagination(); renderCompare();
    }
    const readForm = () => {
      const values = new FormData(form);
      groups.forEach(group => { state[group] = values.getAll('bc_' + group); });
      const invalid = minimum.value !== '' && maximum.value !== '' && Number(minimum.value) > Number(maximum.value);
      maximum.setCustomValidity(invalid ? labels.priceError : '');
      root.querySelector('[data-bikes-price-error]').hidden = !invalid;
      if (!form.reportValidity()) return;
      state.min = minimum.value; state.max = maximum.value;
      page = 1; render(); updateUrl();
    };
    const syncDialog = () => {
      focusFilterButton = false;
      document.documentElement.classList.remove('ct-cl-modal-open');
      if (desktop.matches && !filterDialog.open) filterDialog.show();
      else if (!desktop.matches && filterDialog.open) filterDialog.close();
    };
    root.classList.add('ct-cl-ready');
    syncDialog(); desktop.addEventListener('change', syncDialog);
    root.querySelector('[data-bikes-open-filters]').addEventListener('click', () => {
      if (filterDialog.open) filterDialog.close();
      focusFilterButton = true; filterDialog.showModal(); document.documentElement.classList.add('ct-cl-modal-open');
    });
    const closeFilters = () => { if (!desktop.matches && filterDialog.open) filterDialog.close(); };
    root.querySelector('[data-bikes-close-filters]').addEventListener('click', closeFilters);
    root.querySelector('[data-bikes-show-results]').addEventListener('click', closeFilters);
    filterDialog.addEventListener('close', () => { document.documentElement.classList.remove('ct-cl-modal-open'); if (focusFilterButton) root.querySelector('[data-bikes-open-filters]').focus(); focusFilterButton = false; });
    [filterDialog, compareDialog].forEach(dialog => dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }));
    form.addEventListener('submit', event => { event.preventDefault(); readForm(); });
    form.addEventListener('change', readForm);
    [minimum, maximum].forEach(input => {
      input.addEventListener('input', () => { clearTimeout(priceTimer); priceTimer = setTimeout(readForm, 250); });
      input.addEventListener('blur', () => { clearTimeout(priceTimer); readForm(); });
    });
    root.querySelectorAll('[data-bikes-clear]').forEach(button => button.addEventListener('click', clear));
    root.querySelectorAll('[data-bikes-view]').forEach(button => button.addEventListener('click', () => {
      setView(button.dataset.bikesView);
      try { localStorage.setItem('cyctracCollectionView', view); } catch {}
      updateUrl();
    }));
    sorter.addEventListener('change', () => { page = 1; render(); updateUrl(); });
    root.querySelector('[data-bikes-clear-compare]').addEventListener('click', () => { selected.clear(); renderCompare(); });
    root.querySelector('[data-bikes-open-compare]').addEventListener('click', () => { renderCompare(); compareDialog.showModal(); });
    root.querySelector('[data-bikes-close-compare]').addEventListener('click', () => compareDialog.close());
    render();
    root.addEventListener('ct:bikes-cleanup', () => { clearTimeout(priceTimer); desktop.removeEventListener('change', syncDialog); if (filterDialog.open) filterDialog.close(); if (compareDialog.open) compareDialog.close(); document.documentElement.classList.remove('ct-cl-modal-open'); }, { once: true });
  }
  const run = scope => scope.querySelectorAll('[data-bikes-collection]').forEach(init);
  run(document);
  document.addEventListener('shopify:section:load', event => run(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-bikes-collection]').forEach(root => root.dispatchEvent(new Event('ct:bikes-cleanup'))));
})();
